// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"100":"97adc2f5","453":"d43485f0","547":"211cf059","608":"3ecb8abb","808":"afa639e7"}[chunkId] + ".chunk.js";
};